import {Table, TableContainer} from "@mui/material";
import InvoiceDetailThead from "./dependencies/InvoiceDetailThead";
import InvoiceDetailTbody from "./dependencies/InvoiceDetailTbody";
import React from "react";

const InvoiceDetailTable = ({ invoice, canDelete, onDeleteFee, onAddFee }) => {
  return (
    <TableContainer
      sx={{
        p: '1rem'
      }}
    >
      <Table
        size="small"
        sx={{
          marginY: '2rem',
        }}
      >
        <InvoiceDetailThead canDelete={canDelete} />
        <InvoiceDetailTbody
          invoice={invoice}
          canDelete={canDelete}
          onDeleteFee={onDeleteFee}
          onAddFee={onAddFee}
        />

      </Table>
    </TableContainer>
  )
}

export default InvoiceDetailTable